import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ForgeAutocomplete } from '@tylertech/forge-react';
import { getAllFilterValuesWithPaging, getFilterLabels, simpleAutocompleteValue } from './filterHelpers.js';
import { removeSimpleFilterOption, selectSimpleFilter, addSimpleFilterOptionAndSelectFilter } from './filterHelpers.js';
import TextFieldWrapper from '../TextFieldWrapper/TextFieldWrapper.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { useUser } from '../../../contexts/userContext.js';

const STEP = 10;

const SimpleFilter = ({
  setting,
  innerAppliedFilters,
  setInnerAppliedFilters,
  filterLabelsParams,
  isLinked,
  setIsLinked,
}) => {
  const { costModel } = useUser();
  const [offset, setOffset] = useState(0);
  const { nameConventions } = useNameConventions();
  const ref = useRef(null);
  const FILTER_NAME = `filter_${setting.type}`;

  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    const onEvent = () => {
      setOffset(0);
    };

    el.addEventListener('focusout', onEvent);
    return () => {
      el.removeEventListener('focusout', onEvent);
    };
  }, []);

  const handleChange = (e) => {
    let selectedFilters = e.detail;
    const type = setting.type;
    const foundAppliedFilterIndex = innerAppliedFilters.findIndex(x => x.type === type);

    if (selectedFilters.length === 0 && foundAppliedFilterIndex > -1) {
      removeSimpleFilterOption(setInnerAppliedFilters, innerAppliedFilters, foundAppliedFilterIndex);
    } else if (selectedFilters.length > 0 && foundAppliedFilterIndex > -1) {
      selectSimpleFilter(setInnerAppliedFilters, innerAppliedFilters, foundAppliedFilterIndex, type, selectedFilters);
    } else if (selectedFilters.length > 0) {
      addSimpleFilterOptionAndSelectFilter(setInnerAppliedFilters, innerAppliedFilters, type, selectedFilters);
    }
    setting.isLinked && setIsLinked(!isLinked);
  };

  const handleFilter = (value, options) => {
    const result = options
      .map(filterOption => {
        return { label: filterOption.name, value: { name: filterOption.name, id: filterOption.id } };
      })
      .filter(filterOption => filterOption.label.toLowerCase().includes(value.toLowerCase().trim()))
      .slice(0, STEP);

    return result;
  };

  return (
    <div className="filter" >
      <ForgeAutocomplete
        id={FILTER_NAME}
        ref={ref}
        filter={(value) => handleFilter(value, getAllFilterValuesWithPaging(innerAppliedFilters, setting))}
        on-forge-autocomplete-change={(e) => handleChange(e)}
        multiple
        syncPopupWidth={true}
        value={simpleAutocompleteValue(innerAppliedFilters, setting)}
        observeScroll
        on-forge-autocomplete-scrolled-bottom={() => {
          const newOffset = offset + STEP;

          const autocomplete = document.getElementById(FILTER_NAME);
          const newOptions = setting.options.slice(newOffset, newOffset + STEP).map(filterOption => {
            return { label: filterOption.name, value: { name: filterOption.name, id: filterOption.id } };
          });
          autocomplete.appendOptions(newOptions);

          setOffset(newOffset);
        }}
      >
        <TextFieldWrapper
          popoverIcon
          showClear
          disabled={setting.options.length === 0}
          label={getFilterLabels(setting.type, filterLabelsParams[setting.type], nameConventions, costModel)}
          syncPopupWidth={true}
        />
      </ForgeAutocomplete>
    </div>
  );
};

SimpleFilter.propTypes = {
  setting: PropTypes.object,
  innerAppliedFilters: PropTypes.array,
  setInnerAppliedFilters: PropTypes.func,
  filterLabelsParams: PropTypes.object,
  isLinked: PropTypes.bool,
  setIsLinked: PropTypes.func,
};

export default SimpleFilter;
